import { GroupNodeLabel } from "@features/graph/graphViewModel"
import { AutocompleteProps } from "@mui/material"
import { GraphNodeEdgeData } from "@store/services/converter/types"
import {
  GroupAutocomplete,
  GroupAutocompleteDisabledFilter,
} from "@components/GroupAutocomplete/GroupAutocomplete"

type MuiAutocompleteProps = AutocompleteProps<GroupNodeLabel | null, false, false, false>

type NodeSelectProps = Omit<
  MuiAutocompleteProps,
  "value" | "onChange" | "options" | "renderInput" | "getOptionDisabled" | "disableClearable"
> & {
  label?: string
  graph?: GraphNodeEdgeData
  limitToGroupNodes?: string[] // narrow down selection for nodes only within specified node groups ids
  value: GroupNodeLabel | null
  onChange: (newValue: GroupNodeLabel | null) => void
  options?: GroupNodeLabel[]
  getOptionDisabled?: GroupAutocompleteDisabledFilter[]
  disableClearable?: boolean
}

const NodeSelect = ({
  graph,
  value,
  onChange,
  limitToGroupNodes = [],
  label = "Node",
  options,
  getOptionDisabled,
  sx,
  ...props
}: NodeSelectProps) => {
  if (!graph) return <>No graph param</>
  {
    /*TODO searchFuse*/
  }
  return (
    <GroupAutocomplete
      sx={sx}
      label={label}
      graphData={graph}
      onChange={onChange}
      value={value}
      groupFilter={limitToGroupNodes}
      optionsFilter={options}
      disabledFilter={getOptionDisabled}
      disableClearable={props.disableClearable}
    />
  )
}

export default NodeSelect
